import { Model, HasOne, Attr } from 'spraypaint';
import type { PeriodType } from '@common/utils/type.utils';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

@Model()
class AuditsExportsPostPayrollAnalysisExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-post_payroll_analysis_exports' as const;

  // Attributes
  @Attr() payslipPeriod!: PeriodType;

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsPostPayrollAnalysisExport;
